import styles from './WeChatAddModalWindow.module.scss';
import FormErrorMessage from '@components/FormErrorMessage';
import parse from 'html-react-parser';
import PlacingOrderButtons from '@components/PlacingOrderButtons';
import PlacingOrderHeader from '@components/PlacingOrderHeader';
import Switch from '@components/new/Switch';
import { ButtonType } from '@components/Button';
import { Grid } from '@components/Grid';
import { IWeChatAddModalWindowProps } from './../../types';
import { makeWeChatForLogin } from '@api/apiClient';
import { useMutation } from 'react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const WeChatAddModalWindow: React.FC<IWeChatAddModalWindowProps> = (props: IWeChatAddModalWindowProps): React.ReactElement => {
  const {
    addedWeChat: {
      authTicket,
      phone
    },
    handlerSetIsOpenWeChatAddWindow,
    refetchUseProfile
  } = props;

  const [changePhoneEnabled, setChangePhoneEnabled] = useState<boolean>(true);
  const [addWalletEnabled, setAddWalletEnabled] = useState<boolean>(false);

  const { t } = useTranslation();

  const {
    error: errorMakeWeChatForLogin,
    isLoading: isLoadingMakeWeChatForLogin,
    mutate: mutateMakeWeChatForLogin,
    isError: isErrorMakeWeChatForLogin
  } = useMutation({
    mutationFn: makeWeChatForLogin,
    onSuccess() {
      handlerSetIsOpenWeChatAddWindow(false);
      refetchUseProfile();
    }
  });

  return (
      <Grid>
        <PlacingOrderHeader title={parse(t('profileData.weChatAddModal.title')) as string}/>
        <div className={styles.row}>
          <Switch
            checked={changePhoneEnabled}
            onChange={() => setChangePhoneEnabled(!changePhoneEnabled)}
            title={parse(t('profileData.weChatAddModal.changePhone', { phone: phone })) as string}
          />
        </div>
        <div className={styles.row}>
          <Switch
            checked={addWalletEnabled}
            onChange={() => setAddWalletEnabled(!addWalletEnabled)}
            title={t('profileData.weChatAddModal.addWallet')}
          />
        </div>
        <PlacingOrderButtons
            buttons={[
              {
                action: () => mutateMakeWeChatForLogin({
                  authTicket: authTicket,
                  setPhoneForContact: changePhoneEnabled,
                  useForWallet: addWalletEnabled
                }),
                disabled: isLoadingMakeWeChatForLogin,
                text: t('profileData.weChatAddModal.btnText'),
                type: ButtonType.BLOCK
              }
            ]}
            reverse
        />
        {isErrorMakeWeChatForLogin && <FormErrorMessage error={errorMakeWeChatForLogin}/>}
      </Grid>
  );
};

export default WeChatAddModalWindow;
